import { LoadablePaint } from '@confluence/loadable';

export const RecentSpacesSection = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-RecentSpacesSection" */ './RecentSpacesSection.tsx'))
			.RecentSpacesSection,
});
